export const AuditView = ({ data }) => {
  if (!data) return <p className="text-[17px] font-medium text-[#D6D6D6]">Loading...</p>;
  const entries = data.entries || [];
  return (
    <div className="space-y-4" data-testid="audit-view">
      <p className="text-[17px] font-medium text-[#D6D6D6] max-w-2xl">
        A read-only record of everything consequential — stage moves, deletions, settings changes, automated cleanup. Nothing here can be edited or removed.
      </p>
      <div className="rounded-2xl border border-[#2E2E2E] bg-[#050505] overflow-x-auto">
        <table className="w-full text-[17px] font-medium">
          <thead>
            <tr className="text-[#D6D6D6] font-semibold text-left">
              <th className="p-4">When</th>
              <th className="p-4">Action</th>
              <th className="p-4">Who</th>
              <th className="p-4">Details</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e, i) => (
              <tr key={e.id || i} className="odd:bg-[#111111] text-[#D6D6D6] align-top" data-testid="audit-row">
                <td className="p-4 whitespace-nowrap text-[#D6D6D6]">{new Date(e.created_at).toLocaleString()}</td>
                <td className="p-4 text-white whitespace-nowrap">{(e.action || "").replaceAll("_", " ")}</td>
                <td className="p-4">{e.actor}</td>
                <td className="p-4 text-[#D6D6D6] max-w-[480px] break-words">{JSON.stringify(e.details)}</td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr><td colSpan={4} className="p-4 text-[#D6D6D6]">Nothing on record yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
